/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-unused-vars */
import { useState } from 'react';
import "./HomePage.css"
import images from '../../Asset/Img/img';
import { Link } from 'react-router-dom';
import data from "../../Data/data";
import i18n from '../../i18n/config';
import { useTranslation } from 'react-i18next';

const lngs = {
  tr: { nativeName: 'TR' },
  en: { nativeName: 'EN' }

}

function HomePage() {
  const [pdfUrl, setPdfUrl] = useState('');

  const pdfClick = () => {
    setPdfUrl(data.hpcData);
  }
  const pdfClose = () => {
    setPdfUrl('');
  }
  const { t, i18n } = useTranslation();

  return (

    <div className='home-container'>

      <div className="home-content" >
        {/*Home header start*/}
        <div className="home-header" >
          <div className='header-text'>
            <p>Compounding Excellence </p>
          </div>
          <button title="PDF'i Görüntüle" onClick={pdfClick} className='certifica-img' >
            <img src={images.qualityIsoIcon} alt="certifica" />
          </button>
          {pdfUrl && (
            <div className='iframe-container' onClick={pdfClose} >
              <iframe src={pdfUrl} onClick={(e) => e.stopPropagation()} />
            </div>
          )}
        </div>

        {/*Home header end*/}

        {/*Who are we section start*/}

        <div className='home-our'>

          <div className='our-text'>
            <h3>{t('home-our-text-up')}</h3>
            <p>{t('home-our-text-down')}</p>

          </div>

          <div className='our-header'>
            <h3>{t('home-our-header')}</h3>
          </div>

          <div className='our-img-box'>
            <Link to="/sealing">
              <p>{t('home-our-img-box-one')}</p>
            </Link>
            <Link to="/vibration">
              <p>{t('home-our-img-box-two')}</p>
            </Link>
            <Link to="/drinkwater">
              <p>{t('home-our-img-box-three')}</p>
            </Link>
            <Link to="/">
              <p>{t('home-our-img-box-four')}</p>
            </Link>
            <Link to="/special">
              <p>{t('home-our-img-box-five')}</p>
            </Link>

          </div>

        </div>


        {/*Who are we section end*/}

        {/* Compatibility start */}
        <div className='home-compatibility'>
          <div className='compat-content'>
            <h3>{t('home-compat')}</h3>

            <div className='compat-click-active'>

              <div>
                <img src={images.tickBoxIcon} alt="tick" />
                <p>EN 45545-2</p>
              </div>

              <div>
                <img src={images.tickBoxIcon} alt="tick" />
                <p>EN549 A2 H2 Diaphramgs</p>
              </div>

              <div>
                <img src={images.tickBoxIcon} alt="tick" />
                <p>EN 681 WA</p>
              </div>

              <div>
                <img src={images.tickBoxIcon} alt="tick" />
                <p>VW 2.8.1</p>
              </div>

            </div>

            <div className='brand'>
              <img src={images.bmw} alt="bmw" />
              <img src={images.bosch} alt="bosch" />
              <img src={images.fca} alt="Fca" />
              <img src={images.hella} alt="hella" />
              <img src={images.kiwa} alt="kiwa" />
              <img src={images.manIcon} alt="man-icon" />
              <img src={images.nsf} alt="Nsf" />
              <img src={images.porsche} alt="porsche" />
              <img src={images.scania} alt="scania" />
              <img src={images.ul} alt="UL" />
              <img src={images.volkswagen} alt="wolkswagen" />
              <img src={images.wras} alt="wras" />
            </div>

          </div>
        </div>

        {/* Compatibility end */}


        {/* Announcements start */}
        <div className='home-announcements'>

          <h3>{t('home-announcements-header')}</h3>
          <div className='announcements-box-container'>
            <div className='announcements-box-one'>
              <div className='announcements-content-header-box'>
                <p>{t('home-announcements-box-one-header')}</p>
                <p>01.12.2022</p>
              </div>

              <p>{t('home-announcements-box-one-text-p-one')}</p>

              <p>{t('home-announcements-box-one-text-p-two')}</p>

              <p>{t('home-announcements-box-one-text-p-three')}</p>

            </div>

            <div className='announcements-box-two'>
              <div className='announcements-content-header-box'>
                <p>{t('home-announcements-box-two-header')}</p>
                <p>01.12.2022</p>
              </div>

              <p>{t('home-announcements-box-two-text-p-one')}
              </p>

              <p>{t('home-announcements-box-two-text-p-two')}</p>

              <p>{t('home-announcements-box-two-text-p-three')}</p>

            </div>
          </div>
        </div>

        {/* Announcements end */}

      </div>

    </div>
  )
}

export default HomePage
